import type { PlanSetTemplateExportPermissions } from "building-types/views/planSets";

export const defaultExportPermissions: PlanSetTemplateExportPermissions = {
  "Sales Manager": "ALLOW",
};
